var version = "5.30.0";
let buildVersion;
try {
  buildVersion = process.env.PKG_BUILD_VERSION;
} catch {
}
try {
  buildVersion = buildVersion || // This is replaced by `@sanity/pkg-utils` at build time
  // and must always be references by its full static name, e.g. no optional chaining, no `if (process && process.env)` etc.
  "5.30.0";
} catch {
}
const SANITY_VERSION = buildVersion || `${version}-dev`;
export {
  SANITY_VERSION
};
//# sourceMappingURL=version.js.map
